export default function HandymanHero() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-50 to-emerald-100 pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-emerald-600 text-white text-sm font-medium rounded-full mb-6">
              El Paso Handyman Services
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Find Reliable Handyman Services in El Paso, TX
            </h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Connect with skilled handymen for home repairs, maintenance, and small projects. From fixing doors to mounting TVs, get free quotes from trusted professionals serving El Paso and surrounding areas.
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="#directory" 
                className="px-8 py-4 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors shadow-lg whitespace-nowrap"
              >
                Find Handyman Services
              </a>
              <a 
                href="#services" 
                className="px-8 py-4 bg-white text-emerald-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors border-2 border-emerald-600 whitespace-nowrap"
              >
                View Services
              </a>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/aba1fcd94d448c1ed57145dfee8385e2.jpg"
              alt="Handyman Services El Paso"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
